import { useMutation } from "react-query";
import { useDispatch } from "react-redux";

import { getErrorMessage } from "helpers";
import { autoChecklistService } from "services";
import { uiActions } from "store";
import { ErrorResponse } from "types";

const useMerchantMatchDetailsMutation = ({
	setMerchantMatchDetails,
}: {
	setMerchantMatchDetails: Function;
}) => {
	const dispatch = useDispatch();
	return useMutation(
		({
			applicationId,
			selectedMerchantMatches,
		}: {
			selectedMerchantMatches: number;
			applicationId: string | number | undefined | any;
		}) =>
			autoChecklistService.getMerchantMatchDetails(
				applicationId,
				selectedMerchantMatches,
			),
		{
			onSuccess(data) {
				setMerchantMatchDetails?.(data);
			},
			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: getErrorMessage(error),
					}),
				);
			},
		},
	);
};

export default useMerchantMatchDetailsMutation;
